/* content-slot.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./content-slot.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
var contentSlotStyles = {
  root: "_nd5l8niw _1ul9idpf _1q51v77o _slp31hna"
};
/**
 * __ContentSlot__
 *
 * The content slot is used to nest content in a comment's layout. It should be used inside a CommentLayout.
 *
 */
var ContentSlot = function ContentSlot(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: ax([contentSlotStyles.root])
  }, children);
};
export default ContentSlot;